module.exports = __webpack_public_path__ + "static/img/error.4fcc31ae.svg";